<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div>
          <b-list-group>
            <b-list-group-item
                v-for="activity in items"
                :key="activity.id"
                class="border-left-0 border-right-0 border-top border-bottom-0 pt-4 pb-4"
            >

              <PolicyActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Maintenance\\Policy\\Models\\Policy'"/>
              <PolicyValidationActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Validation\\Models\\Validation'"/>
              <PolicyDocumentActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Maintenance\\Policy\\Models\\PolicyDocument'"/>
            </b-list-group-item>

          </b-list-group>
          <hr class="mt-0"/>
        </div>
        <InfiniteLoading @infinite="loadingHandler">
          <template slot="no-results">
            <span>
              {{ $t('system.no_data') }}
            </span>
          </template>
        </InfiniteLoading>
      </div>
    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import PolicyActivity from '@/components/activity/policy/Policy.vue';
  import PolicyValidationActivity from '@/components/activity/policy/PolicyValidation.vue';
  import InfiniteLoading from 'vue-infinite-loading';
  import PolicyDocumentActivity from '@/components/activity/policy/PolicyDocument.vue';
  export default {
    name: 'PolicyHistory',
    data: function() {
      return {
        process: {},
        items: [],
        currentPage: 1,
        totalRows: 0,
        page: 1
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      }
    },
    components: {
      PolicyActivity,
      PolicyValidationActivity,
      InfiniteLoading,
      PolicyDocumentActivity
    },
    computed: {
      getClient() {
        return this.$store.state.client
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {

      }
    },
    methods: {
      loadingHandler($state) {
        let self = this
        piincHttp.get('activity-log', { params:
          {
            log: this.process.who_am_i + '::' + this.process.id,
            page: this.page,
            client: self.getClient.slug
          }
        }).then(({ data }) => {
          if (data.items.length) {
            self.page += 1;
            self.items.push(...data.items);
            if ($state) {
              $state.loaded();
            }
          } else {
            if ($state) {
              $state.complete();
            }
          }
        });
      }
    },
    created () {
      this.process = this.object;
    }
  }
</script>
